import Ajax from '../util/ajax';
import { macroDeleted } from '../features/macros/macrosSlice';
import { hideDialog } from '../reducers/app';
export function deleteMacro() {
    return (dispatch, getState) => {
        const { edit_macro_dialog } = getState();
        const macro_id = edit_macro_dialog.id;
        if (macro_id == undefined) {
            return;
        }
        const ajax = new Ajax(dispatch);
        const url = '/macro/' + macro_id;
        ajax.del(url, undefined, () => {
            dispatch(macroDeleted(macro_id));
            dispatch(hideDialog());
        });
    };
}
